// https://stackoverflow.com/a/27424770/4322226
// Polyfill for IE
Number.isInteger =
    Number.isInteger ||
    function (value) {
        return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
    };
